import {action, observable} from 'mobx';
import {paramsTypes} from '../SignUpStore';
import {modify} from '@/services/Modify'
import stores from '@/stores';
import log from '@/utils/log';

export type modifyParamsTypes = paramsTypes & {
    code: string;
    newPassword: string;
    uid: string;
}

class ModifyStore {
  
  @observable userAccount: modifyParamsTypes = {
        mobile: '',
        password: '',
        code: '',
        newPassword: '',
        uid: ''
    };
  
  @action.bound async modify () {
      const [error] = await modify(this.userAccount);
      if (error) {
        log({pageId: 'P20',eventId: 'E2004', ext: ''})
        return ;
      }
    log({pageId: 'P20',eventId: 'E2003', ext: ''})
     stores.routingStore.history.push('/');
      window.localStorage.removeItem('userInfo')
  }
  
  @action.bound setUserAccount(userAccount: { [key: string]: string }) {
      this.userAccount = Object.assign({}, this.userAccount, userAccount);
  }
  
  
}

export default ModifyStore;
